<template>
    <div class="form-group">
        <label>Feature Permissions</label>
        <div class="feature-list">
            <div
                v-for="feature in availableFeatures"
                :key="feature.id"
                class="feature-toggle"
                :class="{ active: isSelected(feature) }"
            >
                <slider-toggle-field
                    :label="feature.name"
                    :name="feature.feature"
                    :tooltip="feature.description"
                    :value="isSelected(feature)"
                    :isLocked="isLocked(feature)"
                    :data-test-id="`feature-${feature.feature}-toggle`"
                    @lockClicked="lockedFeatureClicked(feature)"
                    @update="$emit('toggled', feature)"
                ></slider-toggle-field>
            </div>
        </div>
    </div>
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import SliderToggleField from '@/components/SliderToggleField.vue'
import canToast from '@/mixins/canToast'

export default {
    components: { SliderToggleField },

    mixins: [canConfirm, canToast],

    props: ['availableFeatures', 'selectedFeatures'],

    methods: {
        isSelected(feature) {
            return (
                !this.isLocked(feature) &&
                this.selectedFeatures.some((selectedFeature) => selectedFeature.id === feature.id)
            )
        },

        isLocked(feature) {
            return Boolean(feature.organization_id === null && feature.is_premium)
        },

        lockedFeatureClicked(feature) {
            this.confirm({
                header: 'Upgrade Feature',
                message: feature.upsell_message,
                acceptLabel: 'OK',
                rejectLabel: null,
            })
        },
    },
}
</script>

<style scoped>
.feature-list {
    display: grid;
    grid-template-columns: auto auto;
    width: 700px;
    row-gap: 15px;
}
</style>
